<template lang='pug'>
#app
  deploy-notification(file-name='app-public.js')
  chat-notifications
  router-view
</template>

<script>
import faviconUrl from '@/assets/images/favicon/favicon.ico';

import '@/utils/init-table-component';

const components = {
  'deploy-notification': require('@/components/other/deploy-notification').default,
  'chat-notifications': require('./common/other/chat-notifications').default,
};

export default {
  components,
  metaInfo: {
    title: 'Recruit. Retain. Refine.', // default title
    titleTemplate: '%s | advisorey.', // all titles use this template
    htmlAttrs: {
      lang: 'en',
      amp: true,
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      // meta description - override on all indexable pages
      { vmid: 'description', name: 'description', content: 'advisorey.: Recruit. Retain. Refine.' },
    ],
    link: [
      { rel: 'shortcut icon', type: 'image/ico', href: faviconUrl },
    ],
    ...process.env.LEADEREQ_ENV === 'production' && {
      script: [
        // Keep this hash consistent with the font-kit
        { src: '//hello.myfonts.net/count/39de38', async: true },
      ],
    },
  },
  mounted() {
    document.dispatchEvent(new Event('prerender-ready'));
  },
};
</script>


<style lang='less'>
@import '~assets/style/core.less';

#app {
  height: 100%;
}
</style>
